skrilla.directive('userReferral', function () {
    return {
        templateUrl: 'directives/userReferral/userReferral.html',
        scope: {
            user: "="
        },
        controller: function ($scope, searchService, cacheService, modalService, srefService, promotionService, currencyService, queryService, paginationService) {
            $scope.pageKey = "userPromotionClaims";
            $scope.validate = {}
            $scope.getUTC = function (date_) {
                var date = new Date(date_);
                var mins = date.getMinutes();
                date.setMinutes(date.getTimezoneOffset());
                date.setMinutes(mins);
                return date;
            }

            const query = () => {
                const claimsQuery = queryService.getQueryString({claimerId: $scope.user.id}, $scope.pageKey)
                return searchService.get("promotions/claims" + claimsQuery).then(function (response) {
                    $scope.claimsByUser = response.data.result;
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            };
            paginationService.resetPage($scope.pageKey);
            paginationService.pageQuery(query, $scope.pageKey);

            $scope.search = function() {
                searchService.get("users/" + $scope.user.id + "/promotion").then(function (response) {
                    $scope.promotion = response.data;

                    if($scope.promotion.purpose === "REFERRAL"){
                        $scope.promotion.ownerAmount = currencyService.divide($scope.promotion.ownerAmount, $scope.promotion.currency)
                        $scope.promotion.claimerAmount = currencyService.divide($scope.promotion.claimerAmount, $scope.promotion.currency)
                    }

                    $scope.disable = false;
                });
            }
            $scope.search();

            $scope.updateReferral = function(){
                if(promotionService.validatePromotion($scope.promotion, $scope.validate)){
                    modalService.confirm("Are you sure you'd like to update this referral?", function(){
                        const request = {
                            ...$scope.promotion,
                            ownerAmount: currencyService.multiply($scope.promotion.ownerAmount, $scope.promotion.currency),
                            claimerAmount: currencyService.multiply($scope.promotion.claimerAmount, $scope.promotion.currency)
                        }
                        searchService.put("promotions/definitions/" + $scope.promotion.definitionId, request, "Successfully updated user referral").then(function(response){
                            $scope.search();
                        }, function (response) {
                            $scope.promotion.ownerAmount = currencyService.divide($scope.promotion.ownerAmount, $scope.promotion.currency)
                            $scope.promotion.claimerAmount = currencyService.divide($scope.promotion.claimerAmount, $scope.promotion.currency)
                        });
                    })
                }
            }

            $scope.updateActive = function(){
                modalService.confirm("Are you sure you want to update this code?", function(){
                    searchService.put("promotions/codes/" + $scope.promotion.codeId + "/active/" + !$scope.promotion.codeActive,  {}, "Code successfully updated.").then(function () {
                        $scope.search()
                    })
                });
            }

            $scope.perClaimDeposit = function(){
                cacheService.registerObject("perClaimUserId", $scope.user.id);
                modalService.openModal("views/perClaimDeposit/perClaimDepositModal.html", true, 'lg', true, true, function(){
                    $scope.search();
                    query();
                })
            }

            $scope.moveToPromotion = function(){
                cacheService.registerObject("moveUserToCustomerReferral", $scope.user.id);
                modalService.openModal("views/moveUserToCustomerReferral/moveUserToCustomerReferral.html", true, 'lg', true, true, function(){
                    $scope.search();
                })
            }

            $scope.moveToDefault = function(){
                modalService.confirm("Are you sure'd you like to change this user's referral to the default referral?", function(){
                    searchService.put("users/" + $scope.user.id + "/promotion/defaultReferral", {}, "Successfully updated user referral").then(function(response){
                        $scope.search();
                    });
                })
            }

            $scope.moveToCustom = function(){
                cacheService.registerObject("userCustomReferral", $scope.user)
                modalService.openModal("views/createReferralDefinition/createReferralDefinition.html", true, 'lg', true, true, function(){
                    $scope.search();
                })
            }

            $scope.declineClaim = function(claimId){
                promotionService.declineClaim(claimId, function(){
                    query();
                })
            }

            $scope.route = function(claim){
                var data = {id: claim.ownerId}
                switch (claim.ownerType){
                    case "USER":
                    srefService.go("userDetails", data);
                    break;
                }
            }

        }
    };
});
